import { type AISurface, getAISurfaceColors } from '~utils/aiSurfaceColors'

export interface InteractionTypeMeta {
  label: string
  backgroundColor: string
  color: string
  icon: string
}

const INTERACTION_TYPE_META: Record<AISurface, InteractionTypeMeta> = {
  ALL: { label: 'All', icon: 'FilterList', ...spread('ALL') },
  ASSISTANT: { label: 'Assistant', icon: 'AutoAwesome', ...spread('ASSISTANT') },
  CHAT: { label: 'Chat', icon: 'ChatBubbleOutlined', ...spread('CHAT') },
  EMAIL: { label: 'Email', icon: 'Email', ...spread('EMAIL') },
  SEARCH: { label: 'Search', icon: 'Search', ...spread('SEARCH') },
  SMS: { label: 'SMS', icon: 'SmsOutlined', ...spread('SMS') },
  VOICE: { label: 'Voice', icon: 'Phone', ...spread('VOICE') },
  WHATSAPP: { label: 'WhatsApp', icon: 'WhatsApp', ...spread('WHATSAPP') },
}

function spread(surface: AISurface): Pick<InteractionTypeMeta, 'backgroundColor' | 'color'> {
  const { bg, fg } = getAISurfaceColors(surface)
  return { backgroundColor: bg, color: fg }
}

const DEFAULT_ICON = 'ChatBubbleOutlined'

export const getInteractionTypeMeta = (type: string): InteractionTypeMeta =>
  INTERACTION_TYPE_META[type as AISurface] ?? {
    label: type,
    icon: DEFAULT_ICON,
    ...spread(type as AISurface),
  }

export const getDisplayAttributes = (type: string): [string, string, string] => {
  const meta = getInteractionTypeMeta(type)
  return [meta.label, meta.backgroundColor, meta.color]
}
